
export const DELETE_TOKEN = 'DELETE_TOKEN';

export const ADD_TOKEN = 'ADD_TOKEN';

export const ADD_USER = 'ADD_USER';

export const GLOBAL_VARIABLE_ADD_categorias = 'GLOBAL_VARIABLE_ADD_categorias'


